import { Link } from 'react-router-dom';
import { categoriesData } from '@/mocks/homeData';
import { SectionTag, SectionTitle, SectionDescription } from '@/components/base/Card';

export default function CategoriesSection() {
  return (
    <section className="section-padding bg-background-50">
      <div className="container-custom">
        <div className="text-center mb-14">
          <SectionTag>资源分类</SectionTag>
          <SectionTitle>探索豪门国际核心板块</SectionTitle>
          <SectionDescription>
            六大核心板块覆盖全球精英生活的方方面面，点击进入您感兴趣的领域，发现更多可能。
          </SectionDescription>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categoriesData.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-300/60 hover:bg-background-50/80 transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200">
                  {cat.name}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center rounded-full border border-background-200 group-hover:border-primary-300 group-hover:bg-primary-50 transition-all duration-300">
                  <i className="ri-arrow-right-line text-sm text-foreground-400 group-hover:text-primary-600 transition-colors" />
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.description}</p>
              <div className="flex items-center text-xs text-foreground-400">
                <i className="ri-file-text-line mr-1.5" />
                <span>{cat.count} 篇内容</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}